import Model from './BaseModel'
import i18n from '@/plugins/i18n'
import Category from './Category'
import Module from './plans/Module'
import PlanPackage from './plans/PlanPackage'

export default class Activation extends Model {
    static typeModule = 'App\\Models\\Plans\\Module'
    static typePlanPackage = 'App\\Models\\Plans\\PlanPackage'

    resourceName() {
        return 'activations'
    }

    fields() {
        return [
            'category_id',
            'installments',
            'module_id',
            'activatable_id',
            'activatable_type',
            'value',
            'amount',
            'deleted_at',
            'activatable',
        ]
    }

    computed() {
        return {
            active(category) {
                return category.deleted_at ? false : true
            },
            moduleName(activation) {
                let name = activation.module.name
                return name ? name : '-'
            },
            productName(activation) {
                if (
                    activation.activatable_type === Activation.typePlanPackage
                ) {
                    return activation.planPackage
                        ? activation.planPackage.name
                        : i18n.t(
                              'resources.activation.activatable.unknown_plan_package',
                          )
                }
                if (activation.activatable_type === Activation.typeModule) {
                    return activation.module
                        ? activation.module.name
                        : i18n.t(
                              'resources.activation.activatable.unknown_module',
                          )
                }
                return i18n.t('resources.activation.activatable.unknown')
            },
        }
    }

    relationships() {
        return {
            category: new Category(),
            module: new Module(),
            planPackage: new PlanPackage(),
        }
    }

    get tableColumns() {
        return [
            {
                text: i18n.t('resources.activation.attributes.value'),
                value: 'value',
                sortable: false,
            },
            {
                text: i18n.t('resources.activation.attributes.installments'),
                value: 'installments',
                sortable: false,
                align: 'center',
            },
            {
                text: i18n.t('resources.activation.attributes.module'),
                value: 'productName',
                align: 'center',
                sortable: false,
            },
            {
                text: i18n.t('resources.activation.attributes.amount'),
                value: 'amount',
                sortable: false,
            },
            {
                text: i18n.t('resources.default.actions'),
                value: 'action',
                sortable: false,
                align: 'end',
            },
        ]
    }
}
